import ContentBankResourcesUsageDialog from 'components/Grading/ContentBankResourcesUsageDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/ViewSubmission/PageProvider';
import Desktop from 'pages/ViewSubmission/desktop';
import Mobile from 'pages/ViewSubmission/mobile';
import Tablet from 'pages/ViewSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const {
        currentAssignment,
        currentSubmission,
        contentBankResourcesUsageDialog,
        setContentBankResourcesUsageDialog,
    } = props;

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isLoading || !currentAssignment || !currentSubmission ? (
        <Loading />
    ) : (
        <>
            {renderResponsiveLayout(device)}
            <ContentBankResourcesUsageDialog
                open={contentBankResourcesUsageDialog}
                submission={currentSubmission}
                onClose={() => setContentBankResourcesUsageDialog(false)}
            />
        </>
    );
};

export default PageLayout;
